// @flow strict
import * as React from "react"
import * as R from "ramda"
import Table from "@kiwicom/orbit-components/lib/Table"
import TableHead from "@kiwicom/orbit-components/lib/Table/TableHead"
import TableBody from "@kiwicom/orbit-components/lib/Table/TableBody"
import TableRow from "@kiwicom/orbit-components/lib/Table/TableRow"
import TableCell from "@kiwicom/orbit-components/lib/Table/TableCell"

import type { Test } from "./records/Tests"
import RadioButtonsOption from "common/components/RadioButtons/RadioButtonsOption"

type Props = {|
  test: Test,
  handleChange: () => void,
|}

const RenderTable = ({ test, handleChange }: Props) => {
  const ratioSum = R.compose(
    R.sum,
    R.pluck("ratio"),
    R.values,
  )(test.variants)

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell />
          <TableCell>value</TableCell>
          <TableCell>percentage</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {R.compose(
          R.map(variant => (
            <TableRow key={variant.val}>
              <TableCell>
                <RadioButtonsOption
                  mode={{ value: variant.value, cssClass: "normal-case" }}
                  handleChange={handleChange}
                  active={test.winningVariant || test.defaultVariant}
                />
              </TableCell>
              <TableCell>{variant.value}</TableCell>
              <TableCell>{Math.round((10000 * variant.ratio) / ratioSum) / 100} %</TableCell>
            </TableRow>
          )),
          R.sort(R.comparator((a, b) => a.value < b.value)),
          R.values,
        )(test.variants)}
      </TableBody>
    </Table>
  )
}

export default RenderTable
